import { Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Slide, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import Bottom from "../../Bottom";
import { forwardRef, ReactElement, Ref, useEffect, useState } from "react";
import api from "../../../utils/api_v2";
import LodingData from "../../../utils/LodingData";
import Pagination from "react-js-pagination";

import "../../../components/common/PaginationComponent.css";
import useHraStore from "../../../store/hraStores";
import { TransitionProps } from "@mui/material/transitions";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import tabbg from "../../../assets/images/tab_02.png"

// 모달창
const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>;
  },
  ref: Ref<unknown>,
) {
  return <Slide direction="down" ref={ref} {...props} />;
});


const Hra = () => {

  const storeData: any = useHraStore();
  const navigate = useNavigate();

  useEffect(() => {
    getHraList();

    return () => {
      storeData.clear();
    }
  }, [])

  // 모달창
  const [open, setOpen] = useState(false);
  const handleOpen = (item: any) => {
    if (item.has_result) {
      if (!item.is_submitted) setTimeout(() => setOpen(true), 100)
      else navigate('result', { state: item.info.uid })
    }
  };
  const handleClose = () => {
    setOpen(false);
  }

  function getHraList() {
    let familyId: any = localStorage.getItem('ownerFamID');

    LodingData(() => api.get(`customer/api/v2/surveys/families/${encodeURIComponent(familyId)}?survey_uid=hra`)
      .then(res => {
        // console.log(res);
        res.data.data.sort((a: any, b: any) => b.info.year - a.info.year);
        storeData.setHraList(res.data.data);
      })
      .catch(err => {
        console.log(err);
      }))
  }

  function handleHraAnswer() {
    let famId: any = localStorage.getItem('ownerFamID');
    // navigate(`main?famId=${encodeURIComponent(famId)}&assigned_uid=${storeData.targetInfo.uid}&survey_uid=${storeData.targetSurvey.uid}`)

    const items = {
      family_id: famId,
      year: storeData.targetInfo.year,
      // assigned_uid: storeData.targetInfo.uid,
      // survey_uid: storeData.targetSurvey.uid,
    }

    navigate('answer', { state: items })
  }

  function targetLow(info: any, survey: any) {
    storeData.setTargetInfo(info);
    storeData.setTargetSurvey(survey);
  }

  function handlePageChange(page: number) {
    storeData.setHraListParams('pageNum', page - 1);
    getHraList();
  }
  const img = {
    display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
  }

  return (
    <Container className="container">
      <Box sx={img} >
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#b2f7ab', fontWeight: 900, }}>
              검진결과
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ee725', fontWeight: 500, }} gutterBottom>
              뇌심혈관질환 발병위험도 평가
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Typography sx={{ textAlign: 'center !important', mb: 3 }}>제출 된 응답은 수정이 <span style={{ fontWeight: 'bold', color:'red' }}>불가능</span>합니다.</Typography>

      <TableContainer>
        <Table size="small" className="Cl_table" sx={{ width: '80%', ml: "auto", mr: 'auto' }}>
          <TableHead>
            <TableRow>
              <TableCell>연도</TableCell>
              <TableCell>제목</TableCell>
              <TableCell>참여</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              storeData.hraList.length == 0
                ? <TableRow>
                  <TableCell colSpan={3}>해당하는 설문이 없습니다.</TableCell>
                </TableRow>
                : storeData.hraList.map((item: any, idx: number) => {
                  return (
                    <TableRow key={idx} onClick={() => { handleOpen(item); targetLow(item.info, item.info.survey); }}>
                      <TableCell>{item.info.year}</TableCell>
                      <TableCell>
                        {item.info.survey.title}
                        {
                          <Typography component="span" color='gray' fontSize={12}><br />{item.has_result ? '' : `(검진 결과 등록이 필요합니다)`}</Typography>
                        }
                      </TableCell>
                      <TableCell>
                        {
                          item.has_result
                            ? (item.is_submitted ? <Typography sx={{background: '#999', width: '50%', borderRadius: 20, padding: '2px 0px', ml: 'auto', mr:'auto', color:'#fff', fontSize: 14}}>완료</Typography> : <Typography sx={{background: '#0087ff', width: '50%', borderRadius: 20, padding: '2px 0px', ml: 'auto', mr:'auto', color:'#fff', fontSize: 14}}>가능</Typography>)
                            : <Typography sx={{color:'#fff', fontSize: 14, background: '#d10000', width: '50%', borderRadius: 20, padding: '2px 0px', ml: 'auto', mr:'auto'}}>불가</Typography>
                        }
                      </TableCell>
                    </TableRow>
                  )
                })
            }
          </TableBody>
        </Table>
      </TableContainer>

      {/* 모달창 */}
      {
        <Dialog
          open={open}
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
          TransitionComponent={Transition}

        >
          <DialogContent >
            <Container>
              <Box sx={{ textAlign: 'center' }}>
                <ErrorOutlineIcon sx={{ fontSize: 40, color: '#db0000' }} />
                <Box>
                  <Typography sx={{ mt: 3 }}>{`[${storeData.targetInfo.year}년도 ${storeData.targetSurvey.title}]`}</Typography>
                  <Typography sx={{ mt: 1, fontWeight: "bold" }}>완료가 필요합니다.</Typography>
                </Box>
              </Box>
            </Container>
          </DialogContent>

          <DialogActions>
            <Box>
              <Button sx={{ color: '#fff', bgcolor: '#0d6703', '&:hover': { bgcolor: '#074300' } }} onClick={() => handleHraAnswer()}>확인</Button>
              <Button sx={{ color: '#fff', bgcolor: "#888", ml: 1, '&:hover': { bgcolor: '#555' } }} onClick={handleClose}>닫기</Button>
            </Box>
          </DialogActions>
        </Dialog>
      }

      <Grid container className='foot_list'>
        <Pagination
          activePage={storeData.hraListParams.pageNum + 1} // 현재 페이지
          itemsCountPerPage={10} // 한 페이지에 보여줄 아이템 갯수
          totalItemsCount={storeData.hraListCount} // 총 아이템 갯수
          pageRangeDisplayed={10} // paginator의 페이지 범위
          prevPageText={"‹"} // "이전"을 나타낼 텍스트
          nextPageText={"›"} // "다음"을 나타낼 텍스트
          onChange={handlePageChange} // 페이지 변경을 핸들링하는 함수
        />
      </Grid>

      <Bottom />
    </Container>
  )
}

export default Hra;